// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1005":"e373f49e","2731":"e373f49e","7884":"3c0ffecc"}[chunkId] + ".chunk.css";
};